<template>
    <el-card>
        <div class="farm-list-table">
            <el-table
                :data="getOperationList.itens || []"
                :empty-text="translate('main_list_table.no_data')"
                highlight-current-row
            >
                <el-table-column
                    min-width="150px"
                    prop="numeroBl"
                    :label="translate('traceabilityReport.bl_number')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{ scope.row.numeroBl || '-' }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    :formatter='formatDateColumn'
                    min-width="140px"
                    prop="dataBl"
                    :label="translate('traceabilityReport.bl_date')"
                    label-class-name="transaction-list-table_label"
                />

                <el-table-column
                    min-width="150px"
                    prop="armazemOrigem"
                    :label="translate('traceabilityReport.origin_port')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{ scope.row.armazemOrigem }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="150px"
                    prop="armazemDestino"
                    :label="
                        translate('traceabilityReport.destination_port')
                    "
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{ scope.row.armazemDestino }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="160px"
                    prop="empresaDestino"
                    :label="translate('traceabilityReport.counterparty')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{ scope.row.empresaDestino || '-' }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="volumeTon"
                    min-width="140px"
                    align="right"
                    :label="translate('traceabilityReport.cargo_volume')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        {{ displayVolume(scope.row) }}
                    </template>
                </el-table-column>

                <el-table-column
                    :label="translate('main_list_table.actions')"
                    align="center"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <el-dropdown class="action-button" trigger="click">
                            <span class="el-dropdown-link">
                                <i class="mdi mdi-dots-vertical" />
                            </span>
                            <el-dropdown-menu>
                                <el-dropdown-item
                                    icon="el-icon-view"
                                    @click.native="visualizar(scope.row)"
                                >
                                    {{ translate('traceabilityReport.exportTable.action_options.view') }}
                                </el-dropdown-item>

                                <el-dropdown-item
                                    icon="el-icon-download"
                                    @click.native="download(scope.row)"
                                >
                                    {{ translate('traceabilityReport.exportTable.action_options.download') }}
                                </el-dropdown-item>

                                <el-dropdown-item
                                    icon="el-icon-download"
                                    @click.native="downloadReportFile(scope.row)"
                                >
                                    {{ translate('traceabilityReport.exportTable.action_options.download_report') }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <div class="farm-list-table__pagination">
                <div class="total">
                    <span
                        >{{ getOperationList.totalItens }}
                        {{
                            $tc(
                                'relatorio_rastreabilidade.messages.words.results',
                                getOperationList.totalItens
                            )
                        }}</span
                    >
                    <div style="margin: 0 20px"></div>
                    <span>{{ translate('words.views_by_page') }}:</span>
                    <el-pagination
                        @size-change="handleSizeChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="sizes"
                        :total="getOperationList.totalItens"
                    />
                </div>
                <div class="prev_next">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="prev, pager, next, jumper"
                        :total="getOperationList.totalItens"
                    />
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import formatters from '@/utils/formatters';
import RastreabilidadeTransacaoArmazemService from '@/services/RastreabilidadeTransacaoArmazemService';
import RastreabilidadeExportacaoService from '@/services/RastreabilidadeExportacaoService';

export default {
    name: 'ExportListTable',
    components: {},
    props: {
        filters: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            exports: [],
            page: 0,
            size: 10,
            totalElements: 0,
            loading: false
        };
    },
    computed: {
        ...mapState('relatorioRastreabilidadeModule', ['filter']),
        ...mapGetters('relatorioRastreabilidadeModule', ['getOperationList']),
        filterHandler() {
            return [
                this.filter.page,
                this.filter.size,
                this.filter.contract_number
            ];
        }
    },
    mounted() {
        this.$store.commit('relatorioRastreabilidadeModule/SET_FILTER', {
            page: this.page || 1,
            size: this.size,
            type: 4,
            contract_number: this.filters?.searchText ?? ''
        });
    },
    watch: {
        filterHandler() {
            this.fetchOperations();
        },
        filters: {
            handler() {
                this.page = 1;
                this.$store.commit(
                    'relatorioRastreabilidadeModule/SET_FILTER',
                    {
                        ...this.filter,
                        page: this.page,
                        size: this.size,
                        type: 4,
                        contract_number: this.filters?.searchText ?? ''
                    }
                );
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('relatorioRastreabilidadeModule', ['fetchOperations']),

        handleCurrentChange(page) {
            this.page = page;
            this.$store.commit('relatorioRastreabilidadeModule/SET_FILTER', {
                ...this.filter,
                page: this.page
            });
        },

        handleSizeChange(size) {
            this.page = 1;
            this.size = size;
            this.$store.commit('relatorioRastreabilidadeModule/SET_FILTER', {
                ...this.filter,
                page: this.page,
                size: this.size
            });
        },

        translate(key, params = {}) {
            const base = 'relatorio_rastreabilidade.messages';
            const translated = this.$t(`${base}.${key}`, params);
            return translated !== `${base}.${key}`
                ? translated
                : this.$t(`relatorio_rastreabilidade.${key}`, params);
        },

        formatNumber(row, column, reportVolume, index) {
            return formatters.formatNumber(reportVolume);
        },

        displayVolume(row) {
            const volume = row.volumeDestinoTonFormatado ?? row.volumeOrigemTonFormatado ?? null;
            if (!volume) {
                return '-';
            }
            return this.formatNumberColumn(null, null, volume, null);
        },

        formatNumberColumn(row, column, areaHa, index) {
            return formatters.minFormatNumber(areaHa, 3, this.$i18n.locale);
        },

        formatDateColumn(row, column, data, index) {
            return formatters.dateTimeToLocaleString(row.dataBl, {assumeUtc: true, userLocale: this.$i18n.locale}).split(', ')[0];
        },

        formatDateTimeToString(date) {
            if (!date) return [];
            try {
                const str = formatters.dateTimeToLocaleString(date, {
                    assumeUtc: true
                });
                if (!str || typeof str !== 'string') return [];
                return str.split(', ');
            } catch (e) {
                return [];
            }
        },
        visualizar(row) {
            this.$router.push({
                name: 'RelatorioRastreabilidadeCadastro',
                params: { id: row.id }
            });
        },
        async downloadReportFile(row) {
            try {
                const response = await RastreabilidadeTransacaoArmazemService.getTraceabilityReportPdf(row.id);
                const blob = new Blob([response.data], {
                    type: 'application/octet-stream'
                });
                const fileURL = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = fileURL;
                a.download = this.translate('main_list_table.report_file_name_with_extension');
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(fileURL);
            } catch (error) {
                if (error.response?.data instanceof Blob) {
                    const text = await error.response.data.text();
                    const errorData = JSON.parse(text);
                    this.$notify.error({
                        message: this.translate('main_list_table.errors.' + errorData.message),
                        duration: 6000
                    });
                } else {
                    this.$notify.error(this.translate('main_list_table.errors.error_message'));
                }
            }
        },
        async download(row) {
            try {
                const response =
                    await RastreabilidadeExportacaoService.generateExportFile(
                        row.id
                    );

                const contentType =
                    (response &&
                        response.headers &&
                        response.headers['content-type']) ||
                    'application/zip';
                const blob = new Blob([response.data], { type: contentType });

                if (!blob || blob.size === 0) {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.traceability.export.emptyFile'),
                        duration: 6000
                    });
                    return;
                }

                const fileURL = window.URL.createObjectURL(blob);
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;

                const filenameRegex =
                    /filename\*=UTF-8''([^;\r\n]*)|filename=["']?([^;\r\n"']*)["']?/i;
                const contentDisposition =
                    (response &&
                        response.headers &&
                        response.headers['content-disposition']) ||
                    '';
                const match = filenameRegex.exec(contentDisposition);
                const defaultName = this.$t(
                    'relatorio_rastreabilidade.traceability.export.defaultFileName'
                );

                let suggestedName =
                    decodeURIComponent(
                        (match && (match[1] || match[2])) || ''
                    ) || defaultName;

                if (!/\.[A-Za-z0-9]{2,8}$/.test(suggestedName)) {
                    suggestedName = `${suggestedName}.zip`;
                }

                fileLink.setAttribute('download', suggestedName);
                document.body.appendChild(fileLink);
                fileLink.click();

                window.URL.revokeObjectURL(fileURL);
                document.body.removeChild(fileLink);

                this.$notify.success({
                    message: this.$t(
                        'relatorio_rastreabilidade.traceability.export.downloadSuccess'
                    ),
                    duration: 6000
                });
            } catch (e) {
                let message;

                if (e?.response?.data instanceof Blob) {
                    const reader = new FileReader();

                    reader.onload = () => {
                        try {
                            const errorJson = JSON.parse(reader.result);
                            const code = errorJson.message;

                            if (code === 'territorio_multiplos_poligonos_geojson_error_message') {
                                message = this.translate('individual_record.error.' + code, {
                                    territorios: (errorJson.territoriosInvalidos || []).join(', ')
                                });
                            } else if (code) {
                                const baseKey = 'individual_record.error.' + code;
                                const translated = this.translate(baseKey);

                                message =
                                    translated &&
                                    translated !== `relatorio_rastreabilidade.messages.${baseKey}` &&
                                    translated !== `relatorio_rastreabilidade.${baseKey}`
                                        ? translated
                                        : this.translate('individual_record.error.error_message');
                            } else {
                                message = this.translate('individual_record.error.error_message');
                            }

                            this.$notify.error({ message, duration: 6000 });
                        } catch {
                            this.$notify.error({
                                message: this.translate('individual_record.error.error_message'),
                                duration: 6000
                            });
                        }
                    };

                    reader.readAsText(e.response.data);
                    return;
                }

                const code = e?.response?.data?.message;
                if (code === 'territorio_multiplos_poligonos_geojson_error_message') {
                    message = this.translate('individual_record.error.' + code, {
                        territorios: (e.response.data.territoriosInvalidos || []).join(', ')
                    });
                } else {
                    message = code
                        ? this.translate('individual_record.error.' + code)
                        : this.translate('individual_record.error.error_message');
                }

                this.$notify.error({ message, duration: 6000 });
            }

        }
    }
};
</script>

<style scoped lang="scss">
::v-deep .transaction-list-table_label {
    word-break: keep-all !important;
}
.transaction-list_text {
    word-break: keep-all !important;
}
.farm-list-table {
    .el-table {
        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
        }
    }

    .farm-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin-top: 20px;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
</style>
